<template>
    <div>
        <v-card v-if="html">
            <v-card-text v-html="html"/>
        </v-card>
    </div>

</template>

<script>
    import api from "../services/aggrega8-api";

    export default {
        name: 'About',
        computed: {
            selectedProgram: function () {
                return this.$store.state.selectedProgram
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            userDetails: function () {
                return this.$store.state.userDetails
            }
        },
        data: () => ({
            html: null
        }),
        mounted() {
            window.scrollTo(0,0)
            let program;
            if (this.userDetails) {
                if (this.userDetails.currentProgram) program = this.userDetails.currentProgram.id
            }
            if (!program && this.selectedProgram) program = this.selectedProgram.id
            if (!program) {
                program = localStorage.getItem("program")
            }
            let url = "/consumer/about"
            if (program) url += "/" + program
            this.loadProgram(url)

        },
        methods: {
            loadProgram(url) {
                this.showAccessCode = false
                this.$store.dispatch("setExecuting", true)
                api.get(url).then(
                (results) => {
                    this.html = results.data
                },
                (error) => {
                    console.error(error)
                }).then(() => {
                    this.$store.dispatch("setExecuting", false)
                })
            },
        }
    }
</script>
